// Generated by purs version 0.15.0
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Index from "../Foreign.Index/index.js";
import * as Unscramble from "../Unscramble/index.js";
var Result = function (x) {
    return x;
};
var udecodeResult = function (dictDecode) {
    return function (dictDecode1) {
        return {
            unsafeDecode: function (f) {
                var $11 = !Foreign.isUndefined(f.Left);
                if ($11) {
                    return new Data_Either.Left(Unscramble.unsafeDecode(dictDecode)(f.Left));
                };
                return new Data_Either.Right(Unscramble.unsafeDecode(dictDecode1)(f.Right));
            }
        };
    };
};
var showResult = function (dictShow) {
    return function (dictShow1) {
        return Data_Either.showEither(dictShow)(dictShow1);
    };
};
var newtypeResult = {
    Coercible0: function () {
        return undefined;
    }
};
var toEither = /* #__PURE__ */ Data_Newtype.unwrap();
var functorResult = Data_Either.functorEither;
var fromEither = /* #__PURE__ */ Data_Newtype.wrap();
var eqResult = function (dictEq) {
    return function (dictEq1) {
        return Data_Either.eqEither(dictEq)(dictEq1);
    };
};
var encodeResult = function (dictEncode) {
    return function (dictEncode1) {
        return {
            encode: function (v) {
                if (v instanceof Data_Either.Left) {
                    return Foreign.unsafeToForeign({
                        Left: Foreign_Generic_Class.encode(dictEncode)(v.value0)
                    });
                };
                if (v instanceof Data_Either.Right) {
                    return Foreign.unsafeToForeign({
                        Right: Foreign_Generic_Class.encode(dictEncode1)(v.value0)
                    });
                };
                throw new Error("Failed pattern match at Data.Result (line 58, column 5 - line 60, column 64): " + [ v.constructor.name ]);
            }
        };
    };
};
var decodeResult = function (dictDecode) {
    return function (dictDecode1) {
        return {
            decode: function (f) {
                var indexRequired = function (f$prime) {
                    return function (k) {
                        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.index(Foreign_Index.indexString(Data_Identity.monadIdentity))(f$prime)(k))(function (value) {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Applicative.when(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Foreign.isUndefined(value))(Foreign.fail(Data_Identity.monadIdentity)(new Foreign.ForeignError("required key not found: " + k))))(function () {
                                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(value);
                            });
                        });
                    };
                };
                var decodeRight = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(function ($15) {
                    return Result(Data_Either.Right.create($15));
                })(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(indexRequired(f)("Right"))(Foreign_Generic_Class.decode(dictDecode1)));
                var decodeLeft = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(function ($16) {
                    return Result(Data_Either.Left.create($16));
                })(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(indexRequired(f)("Left"))(Foreign_Generic_Class.decode(dictDecode)));
                return Control_Alt.alt(Control_Monad_Except_Trans.altExceptT(Data_List_Types.semigroupNonEmptyList)(Data_Identity.monadIdentity))(decodeLeft)(decodeRight);
            }
        };
    };
};
export {
    Result,
    fromEither,
    toEither,
    newtypeResult,
    functorResult,
    eqResult,
    showResult,
    decodeResult,
    udecodeResult,
    encodeResult
};
//# sourceMappingURL=index.js.map
